/**
 * Data access for the PC Performance dashboard (DEV-6125).
 */

import { fetchWithFallback } from "../OrgUsageAnalytics/api";

/**
 * @param {object} options
 * @param {number} [options.days]
 * @param {string} [options.organizationId]
 * @param {string} [options.env] - prod | dev | local
 */
export const fetchPerformanceReport = ({
  days = 7,
  organizationId = "",
  env = "prod",
} = {}) =>
  fetchWithFallback(
    "/pc-performance/overview",
    {
      days: String(days),
      ...(organizationId ? { organizationId } : {}),
    },
    { env, timeoutMs: 90000 },
  );

/**
 * Recent checklist runs for one loan, with per-task stage detail.
 *
 * @param {object} options
 * @param {string} options.organizationId
 * @param {string} options.loanId
 * @param {number} [options.limit]
 * @param {string} [options.taskId]
 * @param {string} [options.env]
 */
export const fetchLoanRuns = ({
  organizationId,
  loanId,
  limit = 10,
  taskId = "",
  env = "prod",
} = {}) =>
  fetchWithFallback(
    "/pc-performance/loan-runs",
    {
      organizationId,
      loanId,
      limit: String(limit),
      ...(taskId ? { taskId } : {}),
    },
    { env, timeoutMs: 90000 },
  );

/**
 * Latest loans that ran the checklist, newest first.
 *
 * @param {object} options
 * @param {number} [options.days]
 * @param {string} [options.organizationId]
 * @param {number} [options.limit]
 * @param {number} [options.skip]
 * @param {string} [options.env]
 */
export const fetchRecentLoans = ({
  days = 7,
  organizationId = "",
  limit = 10,
  skip = 0,
  env = "prod",
} = {}) =>
  fetchWithFallback(
    "/pc-performance/recent-loans",
    {
      days: String(days),
      limit: String(limit),
      skip: String(skip),
      ...(organizationId ? { organizationId } : {}),
    },
    { env, timeoutMs: 90000 },
  );
